import { AuthType } from '../../domain';
export var accountApiRelativePath = "/account";
export var authApiRelativePath = "/auth";
export var createAccountSettingsApi = function (baseUrl, http) {
    var accountApiUrl = "" + baseUrl + accountApiRelativePath;
    var authApiUrl = "" + baseUrl + authApiRelativePath;
    var loginApiUrl = accountApiUrl + "/login";
    return {
        getAccountTimezone: function () { return http.get(accountApiUrl + "/timezone").then(function (data) { return data.timeZone; }); },
        setAccountTimezone: function (dto) { return http.put(accountApiUrl + "/timezone", dto); },
        getAccountName: function () { return http.get(accountApiUrl + "/name").then(function (data) { return data.name; }); },
        setAccountName: function (dto) { return http.put(accountApiUrl + "/name", dto); },
        getAccountLocales: function () { return http.get(accountApiUrl + "/locales").then(function (data) { return data.locales; }); },
        addAccountLocale: function (dto) {
            return http.post(accountApiUrl + "/locales", dto).then(function (data) { return data.locales; });
        },
        removeAccountLocale: function (dto) {
            return http.delete(accountApiUrl + "/locales/" + dto.locale);
        },
        changeAccountOwner: function (dto) { return http.put(accountApiUrl + "/owner", dto); },
        getSamlLoginSettings: function () { return http.get(authApiUrl + "/providers?authType=" + AuthType.SAML + "&authMethodType=" + 0); },
        setSamlLoginSettings: function (dto) { return http.post(authApiUrl + "/providers", dto); },
        updateSamlLoginSettings: function (dto) { return http.put(authApiUrl + "/providers", dto); },
        getAuthenticationOptions: function () { return http.get(loginApiUrl); },
        enableAuthProvider: function (dto) { return http.post(authApiUrl + "/providers/enable", dto); },
        disableAuthProvider: function (dto) { return http.post(authApiUrl + "/providers/disable", dto); },
        toggleGoogleLogin: function (enabled) { return http.put(loginApiUrl + "/google/enabled", { enabled: enabled }); },
        toggleInternalLogin: function (enabled) { return http.put(loginApiUrl + "/internal/enabled", { enabled: enabled }); },
        getTenantEnabledChannels: function () { return http.get(accountApiUrl + "/activities"); },
        isEnabledHelpWidget: function () { return http.get(accountApiUrl + "/helpWidget/enabled", {}); },
        enableHelpWidget: function () { return http.put(accountApiUrl + "/helpWidget/enable", {}); },
        disableHelpWidget: function () { return http.put(accountApiUrl + "/helpWidget/disable", {}); },
    };
};
//# sourceMappingURL=index.js.map